export default __webpack_public_path__ + "static/media/up.8ae3d0e8.svg";